import { combineReducers } from "redux";
import { types } from "../types/typesAuth";
import {
  authReducer,
  comprobantepagoReducer,
  cotizacionReducer,
  clienteReducer,
  empleadoReducer,
  empresaReducer,
  guiaremisionReducer,
  inventarioReducer,
  localReducer,
  productoReducer,
  resumencomprobanteReducer,
  uiReducer,
  ventaReducer,
  dashboardReducer,
  listaprecioReducer,
  produccionReducer,
  ComprasReducer,
  proveedorReducer,
  cajaReducer,
  monedaReducer,
  colorReducer,
  usuarioReducer,
  centrocostoReducer,
  notificacionReducer,
  pedidoventaReducer,
} from "../reducers";

const appReducer = combineReducers({
  ui: uiReducer,
  auth: authReducer,
  usuario: usuarioReducer,
  producto: productoReducer,
  listaprecio: listaprecioReducer,
  inventario: inventarioReducer,
  venta: ventaReducer,
  local: localReducer,
  empleado: empleadoReducer,
  cliente: clienteReducer,
  comprobantepago: comprobantepagoReducer,
  cotizacion: cotizacionReducer,
  empresa: empresaReducer,
  resumencomprobante: resumencomprobanteReducer,
  guiaremision: guiaremisionReducer,
  dashboard: dashboardReducer,
  produccion: produccionReducer,
  compra: ComprasReducer,
  proveedor: proveedorReducer,
  caja: cajaReducer,
  moneda: monedaReducer,
  color: colorReducer,
  centrocosto: centrocostoReducer,
  notificacion: notificacionReducer,
  pedidoventa: pedidoventaReducer,
});

const initialState = appReducer({}, {});

const rootReducer = (state, action) => {
  if (action.type === types.authUsuarioLogout) {
    state = initialState;
  }
  return appReducer(state, action);
};

export default rootReducer;
